<!--设置各列数据对应关系-->
<template>
  <div class="preview-container">
    <!-- 顶部导航栏 -->
    <el-row class="header-row">
      <el-col :span="24">
        <Header></Header>
      </el-col>
    </el-row>

    <!-- 主体内容区域 -->
    <el-row class="main-content">
      <!-- 左侧菜单 -->
      <el-col :span="4" class="left-menu">
        <MenuList></MenuList>
      </el-col>

      <!-- 右侧内容区 -->
      <el-col :span="20" class="right-content">
        <!-- 操作按钮区域 -->
        <div class="action-bar">
          <el-button @click="back" icon="el-icon-back" size="medium" class="action-button">
            上一步
          </el-button>
          <el-button @click="nextStep" type="primary" icon="el-icon-right" size="medium" class="action-button primary-btn">
            下一步
          </el-button>
          <el-button @click="fillExcelSettings" type="warning" icon="el-icon-magic-stick" size="medium" class="action-button">
            以前导过Excel,填入以前的设置
          </el-button>
          <el-button @click="clearSettings" type="warning" icon="el-icon-delete" size="medium" class="action-button">
            清除已填入的设置
          </el-button>
        </div>

        <!-- 主要内容卡片 -->
        <div class="content-card">
          <!-- 提示信息 -->
          <div class="tip-section">
            <div class="tip-item">
              <i class="el-icon-edit tip-icon"></i>
              <div class="tip-content">
                <span class="tip-title">点击下面表格中的文字可快速设为该列列名。不导入的删除即可，点击列名可修改。</span>
              </div>
            </div>
          </div>

          <!-- 数据预览表格 -->
          <div class="table-wrapper">
            <el-table
              ref="dataList"
              :data="showedList"
              class="data-table"
              border
              stripe
              :header-cell-style="headerCellStyle"
              :cell-style="cellStyle"
              empty-text="这里将会显示数据"
              height="500"
              @header-click="clickHeader"
              @cell-click="handleCellClick">
              <el-table-column
                width="150px"
                header-align="center"
                resizable
                align="center"
                :key="index"
                :label="header.label"
                :prop="header.prop"
                v-for="(header,index) in headList">
                <template slot="header" slot-scope="scope">
                  <div class="header-cell">
                    <div v-if="header.label==header.prop" class="header-default">
                      {{header.label}}
                    </div>
                    <div v-else>
                      <div v-if="header.can_edit==1" class="header-editable">
                        <el-tooltip effect="light" content="允许填表人需要填写或修改本列">
                          <span><i class="el-icon-edit-outline"></i>{{header.label}}</span>
                        </el-tooltip>
                      </div>
                      <div v-else class="header-readonly">
                        <el-tooltip effect="dark" content="禁止修改和填写">
                          <span>{{header.label}}</span>
                        </el-tooltip>
                      </div>
                    </div>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>

          <!-- 数据超过100条的提示 -->
          <div v-if="dataList.length>100" class="data-limit-tip">
            <i class="el-icon-info limit-icon"></i>
            <span class="limit-text">注：此处只是预览数据窗口，数据总共{{dataList.length}}条，这里只显示前100条，不影响导入数据的正确性。</span>
          </div>
        </div>
      </el-col>
    </el-row>

    <!-- 数据预览对话框 -->
    <el-dialog
      v-dialogDrag
      :close-on-click-modal="false"
      title="数据预览"
      :visible.sync="selectColumnTitleDialogVisible"
      width="70%"
      class="preview-dialog">
      <div class="dialog-content">
        <el-table
          ref="dataList"
          :data="showedList"
          class="data-table"
          border
          stripe
          :header-cell-style="headerCellStyle"
          :cell-style="cellStyle"
          empty-text="这里将会是填表人填好的数据"
          height="350">
          <el-table-column
            header-align="center"
            resizable
            align="center"
            :key="index"
            :label="header.label"
            :prop="header.prop"
            v-for="(header,index) in previewDataList">
            <template slot="header" slot-scope="scope">
              <div class="header-cell">
                <div v-if="header.can_edit==1" class="header-editable">
                  <el-tooltip effect="light" content="允许填写">
                    <span><i class="el-icon-edit-outline"></i>{{header.label}}</span>
                  </el-tooltip>
                </div>
                <div v-else class="header-readonly">
                  <el-tooltip effect="dark" content="不可填写">
                    <span>{{header.label}}</span>
                  </el-tooltip>
                </div>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <div v-if="dataList.length>100" class="data-limit-tip" style="margin-top: 15px;">
        <i class="el-icon-info limit-icon"></i>
        <span class="limit-text">注：此处只是预览数据窗口，数据总共{{dataList.length}}条，这里只显示前100条，不影响导入数据的正确性。</span>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button @click="closeDialog">取消</el-button>
        <el-button type="primary" @click="nextPage">下一步</el-button>
      </div>
    </el-dialog>

    <!-- 表格名称对话框 -->
    <el-dialog
      :close-on-click-modal="false"
      title="输入表格名称"
      :visible.sync="inputFormNameDialogVisible"
      class="input-dialog">
      <div class="dialog-body">
        <el-input v-model="form_name" placeholder="输入表格名称" class="form-input"></el-input>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button @click="inputFormNameDialogVisible=false">取消</el-button>
        <el-button type="primary" @click="confrimFormName()">确认</el-button>
      </div>
    </el-dialog>

    <!-- 修改列名对话框 -->
    <el-dialog
      :close-on-click-modal="false"
      title="修改列名称"
      :visible.sync="headLabelDialogVisible"
      class="input-dialog">
      <div class="dialog-body">
        <div class="form-row">
          <span class="form-label">数据列名：</span>
          <el-input v-model="currentHeaderContent" placeholder="输入该列的名称" class="form-input"></el-input>
        </div>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button @click="headLabelDialogVisible=false">取消</el-button>
        <el-button @click="deleteHeaderInfo()" v-if="currentHeaderContent!==''" class="delete-btn">删除</el-button>
        <el-button type="primary" @click="confirmHeaderInfo()">确定</el-button>
      </div>
    </el-dialog>

    <!-- 选择导入类型对话框 -->
    <el-dialog
      :close-on-click-modal="false"
      title="请选择导入表格的用途"
      :visible.sync="importDataConfirmDialogVisible"
      class="import-dialog">
      <div class="dialog-content">
        <div class="dialog-title">两种用途，请选择一个：</div>
        <el-radio-group v-model="import_type" @change="changeImportType" class="radio-group">
          <el-radio :label="0" class="radio-item">
            <div class="radio-content">
              <div class="radio-label">用空表格收集全部数据</div>
              <div class="radio-desc">填表人需要填写所有列中的数据，任何人均可领表填写。</div>
            </div>
          </el-radio>
          <el-radio :label="1" class="radio-item">
            <div class="radio-content">
              <div class="radio-label">用有数据的表格收集部分数据</div>
              <div class="radio-desc">填表人只填写部分数据，只有可以领到表的人才可以填写或修改。</div>
            </div>
          </el-radio>
        </el-radio-group>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button @click="closeImportSelector">取消</el-button>
        <el-button type="primary" @click="nextStepToImport()">下一步</el-button>
      </div>
    </el-dialog>

    <!-- 自动填入设置对话框 -->
    <el-dialog
      title="自动填入设置"
      :visible.sync="selectExcelSettingDialogVisible"
      class="select-dialog">
      <div class="dialog-body">
        <div class="dialog-title">本次导入的Excel与哪次导入的格式是一样的？请选择：</div>
        <el-select
          v-model="selected_settings_index"
          placeholder="请选择"
          :popper-append-to-body="false"
          @change="selectSettingChanged()"
          class="settings-select">
          <el-option
            v-for="(item,index) in excel_settings"
            :key="item.id"
            :label="item.query_name"
            :value="index">
            <span><span class="option-label">{{item.query_name}}</span><span class="option-time">({{item.create_time}})</span></span>
          </el-option>
        </el-select>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button @click="selectExcelSettingDialogVisible=false">取消</el-button>
        <el-button type="primary" @click="matchFields()">立即填入设置</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import MenuList from './menu.vue'
  import Header from './head.vue'
  import '../assets/global.css'
  import tableItem from './tableItem'
  import Utils from '../utils/utils.js'

  export default {
    components: {
      MenuList,
      Header,
      tableItem
    },
    data() {
      return {
        excel_file: '',
        username: '',
        dataList: [],
        oldList: [],
        showedList: [],
        rawDataList: [],

        headList: [],
        buffered_head_list: [],

        headLabelDialogVisible: false,
        selectedHeaderLabel: '',
        selectedHeaderProp: '',
        currentHeaderContent: '',
        selectedColumnIndex: '',

        previewHeaders: [],
        previewDataList: [],

        ImportStructureAndData: false,

        active: 0,
        isCopyFormName: true,
        isCopyFormComment: false,

        startNum: 1,
        endNum: 2,

        startColumnNum: 1,
        endColumnNum: 2,

        headerPreviewData: [],
        form_titles: [],

        form_name: '',
        form_comment: '',

        options: [],
        column_inputed_value: '',
        selectColumnTitleDialogVisible: false,
        selectColumnNameDialogVisible: false,
        inputFormNameDialogVisible: false,

        tableData: [],
        cols: ['', '', '', ''],
        id: '',
        dialogVisible: false,
        searchResultSettingDialogTableVisible: false,
        position: -1,
        selectedExamID: '',
        msg: '',
        configurations: [],
        showPosition: false,

        record: '',

        name_index: 0,
        num_index: 0,
        recordNum: 0,
        columNames: [],
        selectedColumnNames: [],
        newColumnNames: [],
        realColumnNames: [],
        paperScores: [],
        columnCount: 0,
        rowcount: 0,
        dialogFormVisible: false,
        form: {},
        resData: '',
        loadFromMemory: 'memory',

        settingColumnVisible: false,
        currentPaperScore: 0,
        currentColumn: -1,

        previewColumnLables: [],
        previewTableData: [],

        data_type: ['文本', '数字', '日期', '日期及时间', '单选', '多选', '图片', '视频', '定位'],
        is_optional: ['必须填写', '可以填写'],
        column_types: [],
        selectedColumyType: '',
        currentColumnTitle: '',
        currentColumnDescription: '',
        currentColumnSample: '',
        showColumnSample: false,

        previewHeader: [],
        imageSrc: '',
        excel_src_name: '',
        default_image_url: '/wansearch/images/default_header.png',
        header_image_url: '',
        excel_column_count: 1,
        showRange: false,

        headRange: '',
        previewSuccess: false,

        form_headers: [],
        header_count: 0,

        selectedTypeValue: '',
        dataTypes: [{
            value: '文本',
            label: '可输入任何内容'
          },
          {
            value: '数字',
            label: '只能输入数字'
          }, {
            value: '身份证号',
            label: '只能输身份证号'
          },
          {
            value: '手机号',
            label: '只能输手机号'
          },
          {
            value: '日期',
            label: 'xxxx年xx月xx日'
          },
          {
            value: '年月',
            label: 'xxxx年xx月'
          },
          {
            value: '日期时间',
            label: 'xxxx年xx月xx日 xx点xx分'
          },
          {
            value: '自动时间',
            label: '自动填入填表时间'
          },
          {
            value: '日期范围',
            label: 'xxxx年xx月xx日至xxxx年xx月xx日'
          },
          {
            value: '图片',
            label: '上传一张图片'
          },
          {
            value: '视频',
            label: '上传一个视频文件'
          },
          {
            value: 'Email邮箱',
            label: '电子邮箱地址'
          },
          {
            value: '车牌号',
            label: '只能输入车牌'
          },
          {
            value: '签名',
            label: '手写签名'
          },
          {
            value: '定位',
            label: '自动填写填表人位置'
          }
        ],

        importDataConfirmDialogVisible: false,

        is_import_data: '',
        buffered_datalist: [],
        empty_list: [],

        selectedEditTypeValue: '',
        editTypes: [{
            value: '1',
            label: '允许填表人填写或修改'
          },
          {
            value: '0',
            label: '禁止填表人填写或修改'
          }
        ],

        currentHeaderComment: '',

        import_type: '',


        selectExcelSettingDialogVisible: false,
        excel_settings: [],
        selected_settings_index: '',
        selected_settings: '',

        form_id: '',
        form_name: ''

      }
    },
    created() {
      this.username = this.$session.get('USERNAME')
      this.excel_file = this.$route.params.excel_file

      this.form_id = this.$route.params.form_id
      this.form_name = this.$route.params.form_name

      this.loadData()
    },
    methods: {
      loadData() {
        let that = this

        var requestUrl = '/wansearch/web/_load_preview_data_ai.jsp'

        const load = this.$loading({
          lock: true,
          text: '正在上传和解析数据，请耐心等待...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })

        this.axios.get(requestUrl, {
            params: {
              username: that.username,
              excel_file: that.excel_file
            }
          }).then(function(response) {
            load.close()

            that.headList = response.data.excel_data.HEADERS
            that.buffered_head_list = response.data.excel_data.HEADERS

            var totalRowNum = response.data.excel_data.TOTAL_ROW_NUM

            that.dataList = response.data.excel_data.EXCEL_ROWS
            that.oldList = that.dataList

            if (totalRowNum < 100) {
              that.showedList = that.dataList
            } else {
              that.showedList = that.dataList.slice(0, 99)
            }

            if (totalRowNum > 0) {
              if (that.dataList.length === 0) {
                return
              }

              that.$refs.dataList.doLayout()
            } else {
              that.$message.error('导入数据条数为0，请检查表格是否为空！')
            }

            var firstRowData = that.dataList[0]
            for (var i = 0; i < that.headList.length; i++) {
              var lableValue=firstRowData['第' + i + '列']
              if(!Utils.isEmpty(lableValue)){
                that.headList[i].label =lableValue
              }
            }

          })
          .catch(function(error) {
            console.log(error)
            load.close()
          })
      },

      clickHeader(column, event) {
        console.log(column)

        var pStr = column.property
        var numArr = pStr.match(/\d+/g)
        var indexStr = numArr.join('')
        this.selectedColumnIndex = indexStr

        let prop = column.property
        let label = ''

        for (var i = 0; i < this.headList.length; i++) {
          if (prop === this.headList[i].prop) {
            label = this.headList[i].label
            break
          }
        }

        if (this.headList[i].label === this.headList[i].prop) {
          this.currentHeaderContent = ''
          this.currentHeaderComment = ''
          this.selectedTypeValue = ''
          this.selectedEditTypeValue = ''
        } else {
          this.currentHeaderContent = label
          this.selectedTypeValue = this.headList[i].data_type
          this.selectedEditTypeValue = this.headList[i].can_edit
          this.currentHeaderComment = this.headList[i].comment
        }

        this.selectedHeaderProp = prop

        this.headLabelDialogVisible = true
      },

      handleCellClick(row, column, cell, event) {

        let prop = column.property
        var pos = 0

        for (var i = 0; i < this.headList.length; i++) {
          if (prop === this.headList[i].prop) {
            pos = i
            this.selectedColumnIndex = pos
            break
          }
        }

        let value = row[prop]

        if (Utils.isEmpty(value)) {
          return
        }

        if (this.headList[pos].label === value) {
          this.headList[pos].label = this.headList[pos].prop
          return
        }

        var msg = '要把"' + value + '"设为本列列名吗？'
        let that = this
        this.$confirm(msg, '提示', {
          confirmButtonText: '设为列名',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          that.headList[pos].label = value

          that.$message.success(prop + '列名已修改为:"' + value + '"，点击列表头文字可设置更多内容。')

          that.$refs.dataList.doLayout()
        })
      },
      confirmHeaderInfo() {
        if (this.currentHeaderContent === '') {
          this.$message.error('请输入列名称')
          return
        }

        for (var i = 0; i < this.headList.length; i++) {
          if (this.selectedHeaderProp === this.headList[i].prop) {
            this.headList[i].label = this.currentHeaderContent
            this.headList[i].data_type = this.selectedTypeValue
            this.headList[i].can_edit = this.selectedEditTypeValue
            this.headList[i].comment = this.currentHeaderComment

            this.$forceUpdate()
            break
          }
        }

        this.headLabelDialogVisible = false
        this.selectedTypeValue = ''
        this.selectedEditTypeValue = ''
        this.currentHeaderComment = ''
      },

      deleteHeaderInfo() {
        this.currentHeaderContent = ''
        this.currentHeaderComment = ''
        this.selectedTypeValue = ''
        this.selectedEditTypeValue = ''

        this.headList[this.selectedColumnIndex].label = this.headList[this.selectedColumnIndex].prop
        this.headLabelDialogVisible = false
      },

      fieldNameIsValid() {
        var isValid = true

        for (var i = 0; i < this.headList.length; i++) {
          var currentLabel = this.headList[i].label
          for (var k = i + 1; k < this.headList.length; k++) {
            if (currentLabel === this.headList[k].label) {
              isValid = false
              this.$message.error('"' + currentLabel + '"列名重复,请点击表头修改列名！')
              break
            }
          }
        }
        return isValid
      },

      getDuplicateFieldName() {
        var dFieldName = ''

        for (var i = 0; i < this.headList.length; i++) {
          var currentLabel = this.headList[i].label
          for (var k = i + 1; k < this.headList.length; k++) {
            if (currentLabel === this.headList[k].label) {
              dFieldName = currentLabel
              break
            }
          }
        }
        return dFieldName
      },

      hasSettingColumnName() {
        var setted = false

        for (var i = 0; i < this.headList.length; i++) {
          if (this.headList[i].prop !== this.headList[i].label) {
            setted = true
            break
          }
        }

        return setted
      },
      nextStep() {
        if (!this.hasSettingColumnName()) {
          this.$message.error('请选择数据列！')
          return
        }

        var duplicateFieldName = this.getDuplicateFieldName()
        if (!Utils.isEmpty(duplicateFieldName)) {
          this.$message.error('"' + duplicateFieldName + '"列名重复,请点击表头修改列名！')
          return
        }

        this.is_import_data = true
        this.ImportStructureAndData = true

        this.showImportPreview()
      },
      confrimImportDataFormName() {
        this.is_import_data = true
        this.ImportStructureAndData = true
        this.showImportPreview()
      },
      confrimNotImportDataFormName() {
        this.is_import_data = false
        this.ImportStructureAndData = false
        this.showImportPreview()
      },
      showImportPreview() {
        this.previewDataList = []
        this.empty_list = []

        this.buffered_datalist = this.dataList
        console.log(this.buffered_datalist)

        for (var i = 0; i < this.headList.length; i++) {
          if (this.headList[i].prop !== this.headList[i].label) {
            let header = {
              prop: this.headList[i].prop,
              label: this.headList[i].label,
              data_type: this.headList[i].data_type,
              can_edit: this.headList[i].can_edit,
              comment: this.headList[i].comment
            }

            this.previewDataList.push(header)
          }

          var cName = this.headList[i].prop
          let emptyItem = {}
          emptyItem[cName] = ''
          this.empty_list.push(emptyItem)
        }

        if (this.is_import_data === false) {
          this.dataList = this.empty_list
        } else {
          this.dataList = this.filterList(this.buffered_datalist, this.previewDataList)
        }

        this.selectColumnTitleDialogVisible = true
      },
      filterList(buffered_datalist, selectHeaderList) {
        let tmpList = []

        for (var i = 0; i < buffered_datalist.length; i++) {
          let row = buffered_datalist[i]

          var tmpstr = ''
          for (var j = 0; j < selectHeaderList.length; j++) {
            var headerName = selectHeaderList[j].prop
            var cellValue = '' + row[headerName]
            cellValue = cellValue.trim()
            tmpstr = tmpstr + cellValue
          }

          if (!Utils.isEmpty(tmpstr)) {
            tmpList.push(row)
          }
        }

        return tmpList
      },
      nextPage() {
        var tmpDataList = JSON.stringify(this.dataList)
        var finalHeaderList = JSON.stringify(this.previewDataList)

        var import_data = '1'

        this.$router.push({
          name: 'excel_data_import_final_step',
          params: {
            dataList: tmpDataList,
            headList: finalHeaderList,
            import_data: import_data,
            form_id: this.form_id,
            form_name: this.form_name
          }
        })
      },
      preStep() {
        if (this.active > 0) {
          this.active = this.active - 1
        }
      },
      back() {
        this.$router.back()
      },

      cancelPreviewSetting() {
        this.previewColumnLables.length = 0
        this.dialogFormVisible = false
        this.previewTableData.length = 0
      },
      closeDialog() {
        this.showRange = false
        this.selectColumnTitleDialogVisible = false
        this.previewSuccess = false
      },
      convertHeader(label) {
        if (label == null || label === 'null') {
          return ''
        } else {
          return label
        }
      },
      deleteRow(index, dataList) {
        dataList.splice(index, 1)
        this.$forceUpdate()
      },
      checkImportStateChange(checked) {
        if (checked === true) {
          this.dataList = this.filterList(this.buffered_datalist, this.previewDataList)
          this.is_import_data = true
        } else {
          this.dataList = this.empty_list
          this.is_import_data = false
        }

        this.$forceUpdate()
      },
      changeImportType(value) {
        this.dataList = this.oldList
      },
      closeImportSelector() {
        this.dataList = this.oldList
        this.importDataConfirmDialogVisible = false
      },
      clearSettings() {
        for (var l = 0; l < this.newColumnNames.length; l++) {
          this.newColumnNames[l] = ''
        }

        this.$forceUpdate()

        this.$message.success('清除成功！')
      },
      fillExcelSettings() {
        let that = this

        var requestUrl = '/wansearch/web/_load_excel_setting_list.jsp'
        this.axios.get(requestUrl, {
            params: {
              equipment: that.username
            }
          }).then(function(response) {
            that.excel_settings = response.data.settings

            if (that.excel_settings.length > 0) {
              that.selectExcelSettingDialogVisible = true
            } else {
              that.$alert('您第一次使用需要手工匹配,以后使用就可以选择啦,辛苦您这次选一下！')
            }

            that.$forceUpdate()

          })
          .catch(function(error) {
            console.log(error)
            that.$message(error)
            that.selectExcelSettingDialogVisible = true
          })

      },
      getSelectedColumnSetting(column_name_prop, columnSettingsArray) {
        var tmpObj = ''
        for (var i = 0; i < columnSettingsArray.length; i++) {
          let column = columnSettingsArray[i]
          if (column_name_prop == column.prop) {
            tmpObj = column
            break
          }
        }

        return tmpObj
      },
      matchFields() {

        this.headList = this.buffered_head_list

        let array = JSON.parse(this.selected_settings)
        for (var i = 0; i < this.headList.length; i++) {
          var prop = '第' + i + '列'
          let tmpColumn = this.getSelectedColumnSetting(prop, array)

          if (tmpColumn == '') {
            this.headList[i].label = prop
          } else {
            this.headList[i].label = tmpColumn.label
            this.headList[i].data_type = tmpColumn.data_type
            this.headList[i].can_edit = tmpColumn.can_edit
            this.headList[i].comment = tmpColumn.comment
          }
        }

        this.$nextTick(() => {
          this.$refs.dataList.doLayout();
        })
        this.$forceUpdate()

        this.$message.success('匹配完成！为确保匹配正确，请务必人工核对一遍!')
        this.selectExcelSettingDialogVisible = false

      },
      selectSettingChanged() {

        var index = this.selected_settings_index
        this.selected_settings = this.excel_settings[index].settings

      }

    }
  }
</script>

<style scoped>
/* ==================== 页面整体布局 ==================== */
.preview-container {
  min-height: 100vh;
  background: linear-gradient(135deg, #f5f7fa 0%, #e4e8eb 100%);
}

/* ==================== 操作按钮区域 ==================== */
.action-bar {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  padding: 18px 22px;
  background: #fff;
  border-radius: 12px;
  margin-bottom: 20px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.05);
}

.action-button {
  border-radius: 8px;
  padding: 10px 20px;
  font-size: 14px;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  gap: 6px;
}

.action-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.action-button.primary-btn {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border: none;
  color: #fff;
}

.action-button.primary-btn:hover {
  background: linear-gradient(135deg, #5a71d6 0%, #6a4190 100%);
}

/* ==================== 主要内容卡片 ==================== */
.content-card {
  background: #fff;
  border-radius: 12px;
  padding: 22px 25px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
  animation: fadeIn 0.4s ease;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* ==================== 提示信息区域 ==================== */
.tip-section {
  margin-bottom: 20px;
}

.tip-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 14px 18px;
  background: linear-gradient(135deg, #fff9e6 0%, #fff3cc 100%);
  border-left: 4px solid #faad14;
  border-radius: 0 8px 8px 0;
}

.tip-icon {
  font-size: 20px;
  color: #faad14;
  flex-shrink: 0;
}

.tip-content {
  flex: 1;
}

.tip-title {
  font-size: 13px;
  color: #594d00;
  line-height: 1.5;
}

/* ==================== 表格容器 ==================== */
.table-wrapper {
  margin-top: 15px;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #e8e8e8;
}

.data-table {
  border-radius: 8px;
  overflow: hidden;
}

.data-table >>> .el-table__header-wrapper {
  border-bottom: 2px solid #e9ecef;
}

.data-table >>> .el-table__header th {
  background: #f8f9fa;
  color: #2c3e50;
  font-weight: 600;
  font-size: 13px;
  padding: 12px 0;
}

.data-table >>> .el-table__row {
  transition: all 0.3s ease;
}

.data-table >>> .el-table__row:hover {
  background: rgba(0, 0, 0, 0.02);
}

.data-table >>> .el-table__row:nth-child(even) {
  background: #ffffff;
}

.data-table >>> .el-table__row:nth-child(even):hover {
  background: rgba(0, 0, 0, 0.02);
}

.data-table >>> .el-table__empty-text {
  color: #adb5bd;
  font-size: 14px;
  padding: 30px 0;
}

/* ==================== 表头单元格样式 ==================== */
.header-cell {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
}

.header-default {
  color: #95a5a6;
  font-weight: 500;
  text-decoration: line-through;
}

.header-editable {
  color: #e74c3c;
  font-weight: 600;
  text-decoration: underline;
}

.header-editable span {
  display: flex;
  align-items: center;
  gap: 4px;
}

.header-readonly {
  color: #2c3e50;
  font-weight: 500;
  text-decoration: underline;
}

/* ==================== 数据超过提示 ==================== */
.data-limit-tip {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 16px;
  background: #fff7e6;
  border-radius: 8px;
  border-left: 4px solid #faad14;
  margin-top: 20px;
}

.limit-icon {
  font-size: 18px;
  color: #faad14;
}

.limit-text {
  font-size: 13px;
  color: #d46b08;
  line-height: 1.6;
}

/* ==================== 对话框通用样式 ==================== */
.preview-dialog >>> .el-dialog,
.input-dialog >>> .el-dialog,
.import-dialog >>> .el-dialog,
.select-dialog >>> .el-dialog {
  border-radius: 16px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);
  overflow: hidden;
}

.preview-dialog >>> .el-dialog__header,
.input-dialog >>> .el-dialog__header,
.import-dialog >>> .el-dialog__header,
.select-dialog >>> .el-dialog__header {
  background: #ffffff;
  padding: 20px 20px 15px 20px;
  border-bottom: 1px solid #f0f0f0;
}

.preview-dialog >>> .el-dialog__title,
.input-dialog >>> .el-dialog__title,
.import-dialog >>> .el-dialog__title,
.select-dialog >>> .el-dialog__title {
  color: #2c3e50;
  font-size: 17px;
  font-weight: 600;
}

.preview-dialog >>> .el-dialog__headerbtn .el-dialog__close,
.input-dialog >>> .el-dialog__headerbtn .el-dialog__close,
.import-dialog >>> .el-dialog__headerbtn .el-dialog__close,
.select-dialog >>> .el-dialog__headerbtn .el-dialog__close {
  color: #666;
}

.preview-dialog >>> .el-dialog__body,
.input-dialog >>> .el-dialog__body,
.import-dialog >>> .el-dialog__body,
.select-dialog >>> .el-dialog__body {
  padding: 25px 30px;
}

/* 对话框内容区域 */
.dialog-content {
  padding: 10px;
  max-height: 60vh;
  overflow-y: auto;
}

.dialog-title {
  font-size: 15px;
  font-weight: 600;
  color: #2c3e50;
  margin-bottom: 15px;
}

/* 表单输入 */
.form-row {
  display: flex;
  align-items: center;
  gap: 15px;
}

.form-label {
  font-size: 14px;
  font-weight: 500;
  color: #495057;
  min-width: 90px;
  text-align: right;
}

.form-input {
  flex: 1;
}

.form-input >>> .el-input__inner {
  font-size: 14px;
  border-radius: 8px;
  border: 2px solid #e9ecef;
  padding: 12px 15px;
  transition: all 0.3s ease;
}

.form-input >>> .el-input__inner:focus {
  border-color: #667eea;
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.2);
}

/* 单选框组 */
.radio-group {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.radio-item {
  padding: 15px 18px;
  border: 1px solid #e8e8e8;
  border-radius: 10px;
  transition: all 0.3s ease;
}

.radio-item:hover {
  border-color: #667eea;
  background: rgba(102, 126, 234, 0.02);
}

.radio-item.is-checked {
  border-color: #667eea;
  background: rgba(102, 126, 234, 0.08);
}

.radio-content {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.radio-label {
  font-size: 14px;
  font-weight: 600;
  color: #2c3e50;
}

.radio-desc {
  font-size: 12px;
  color: #6c757d;
  line-height: 1.5;
}

/* 选择器 */
.settings-select {
  width: 100%;
}

.settings-select >>> .el-input__inner {
  font-size: 14px;
  border-radius: 8px;
  border: 2px solid #e9ecef;
  padding: 12px 15px;
  transition: all 0.3s ease;
}

.settings-select >>> .el-input__inner:focus {
  border-color: #667eea;
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.2);
}

.option-label {
  font-size: 14px;
  font-weight: 600;
  color: #2c3e50;
}

.option-time {
  font-size: 12px;
  color: #adb5bd;
  margin-left: 8px;
}

/* 对话框底部按钮 */
.dialog-footer {
  padding: 15px 20px 20px 20px;
  border-top: 1px solid #f0f0f0;
  text-align: center;
}

.dialog-footer >>> .el-button {
  border-radius: 8px;
  padding: 10px 25px;
  font-size: 14px;
}

.dialog-footer >>> .el-button--primary {
  background: #667eea;
  border: none;
}

.dialog-footer >>> .el-button--primary:hover {
  background: #5a71d6;
}

.delete-btn {
  color: #ffffff;
  background: #e74c3c;
  border-color: #e74c3c;
}

.delete-btn:hover {
  background: #c0392b;
  border-color: #c0392b;
  color: #ffffff;
}

/* ==================== 表格滚动条美化 ==================== */
.data-table >>> .el-table__body-wrapper::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

.data-table >>> .el-table__body-wrapper::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 4px;
}

.data-table >>> .el-table__body-wrapper::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 4px;
}

.data-table >>> .el-table__body-wrapper::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}

/* ==================== 响应式设计 ==================== */
@media screen and (max-width: 1200px) {
  .content-card {
    padding: 18px 20px;
  }
  
  .action-bar {
    padding: 15px 18px;
  }
}

@media screen and (max-width: 992px) {
  .action-bar {
    gap: 10px;
  }
  
  .action-button {
    padding: 8px 16px;
    font-size: 13px;
  }
}

@media screen and (max-width: 768px) {
  .content-card {
    padding: 15px;
    border-radius: 10px;
  }
  
  .action-bar {
    flex-direction: column;
    padding: 12px 15px;
  }
  
  .action-button {
    width: 100%;
    justify-content: center;
  }
  
  .tip-item {
    padding: 12px 15px;
  }
  
  .dialog-footer {
    flex-direction: column;
  }
  
  .dialog-footer >>> .el-button {
    width: 100%;
  }
  
  .preview-dialog >>> .el-dialog,
  .input-dialog >>> .el-dialog,
  .import-dialog >>> .el-dialog,
  .select-dialog >>> .el-dialog {
    width: 90% !important;
  }
}

@media screen and (max-width: 480px) {
  .table-wrapper {
    border-radius: 8px;
  }
  
  .data-table >>> .el-table__header th {
    font-size: 11px;
    padding: 8px 0;
  }
  
  .header-default,
  .header-editable,
  .header-readonly {
    font-size: 11px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/excel_data_preview_ai.vue